exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logs-content{padding:10px;box-sizing:content-box;width:100%;overflow:auto;line-height:24px;font-size:14px}.version-oneLevel{padding-left:20px}.version-oneLevel ul{padding-left:10px}.submodule-list{padding-left:14px}h2{margin:16px 0}h3{margin:10px 0}h4{margin:6px 0}pre{font-family:Consolas,Menlo,Courier,monospace}", ""]);

// exports
